import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.96967 15.5303C4.67678 15.2374 4.67678 14.7626 4.96967 14.4697L10.9697 8.46967C11.2626 8.17678 11.7374 8.17678 12.0303 8.46967L18.0303 14.4697C18.3232 14.7626 18.3232 15.2374 18.0303 15.5303C17.7374 15.8232 17.2626 15.8232 16.9697 15.5303L11.5 10.0607L6.03033 15.5303C5.73744 15.8232 5.26256 15.8232 4.96967 15.5303Z",
		fill: "currentColor"
	})
});
export { SvgIconChevronUp as ReactComponent };
